import { validate } from '@angular/forms/signals';
import { isAfter, isValid, parse, startOfDay } from 'date-fns';

interface DateRangeValidatorOptions {
  format?: string;

  message?: string;

  invalidStartDateMessage?: string;

  invalidEndDateMessage?: string;
}

export function validateDateRange(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  startDateField: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  endDateField: any,
  options: DateRangeValidatorOptions,
) {
  const input: DateRangeValidatorOptions = {
    format: 'dd-MM-yyyy',
    message: `De startdatum moet voor de einddatum liggen.`,
    ...options,
  };
  validate<string | Date>(startDateField, ({ value, valueOf }) => {
    const start = value();
    if (!isValid(start)) {
      return {
        kind: 'startDate',
        message: options.invalidStartDateMessage ?? 'De startdatum is ongeldig.',
      };
    }

    const end = valueOf<string | Date>(endDateField);
    if (!isValid(end)) {
      return {
        kind: 'endDate',
        message: options.invalidEndDateMessage ?? 'De einddatum is ongeldig',
      };
    }

    const startDate: Date =
      typeof start === 'string'
        ? parse(input.format as string, start, startOfDay(new Date()))
        : startOfDay(start);
    const endDate: Date =
      typeof end === 'string'
        ? parse(input.format as string, end, startOfDay(new Date()))
        : startOfDay(end);

    if (isAfter(startDate, endDate)) {
      return { kind: 'tsRangeNotInRange', message: options.message };
    }

    return null;
  });
}
